module.exports = __webpack_public_path__ + "static/media/mobile6.6cb747e9.jpg";